import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

export const PublicFooter = () => {
  const { t } = useLang();
  const cols = [
    {
      title: t.footer.colPlatform,
      items: [
        { to: "/#comparativa", label: t.footer.how },
        { to: "/contacto", label: t.footer.requestApp },
      ],
    },
    {
      title: t.footer.colResources,
      items: [
        { to: "/soporte", label: t.footer.support },
        { to: "/contacto", label: t.footer.contact },
        { to: "/privacidad", label: t.footer.privacy },
        { to: "/login", label: t.nav.access },
      ],
    },
  ];
  return (
    <footer className="bg-neutral-100 text-neutral-700">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="mb-4">
            <img src="/domifood-logo.png" alt="Domifood" className="h-11 w-auto" />
          </div>
          <p className="text-sm text-neutral-600 max-w-xs leading-relaxed">{t.footer.tagline}</p>
          <p className="mt-5 text-xs text-neutral-500 font-mono">
            admin.tudominio.com · restaurant.tudominio.com
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-bold text-neutral-900 text-sm uppercase tracking-widest mb-4">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.items.map((it) => (
                <li key={it.label}>
                  {it.to.startsWith("/#") || it.to.includes("?") ? (
                    <a href={it.to} className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">{it.label}</a>
                  ) : (
                    <Link to={it.to} className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors">{it.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-neutral-500">
          <span>© {new Date().getFullYear()} {t.footer.rights}</span>
          <span>{t.footer.madeWith}</span>
        </div>
      </div>
    </footer>
  );
};
